import { PettyCash } from '../../types';

export const generatePettyCashTemplate = (pettyCash: PettyCash): string => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Petty Cash Statement - كشف العهدة المالية اليومي</title>
  <style>
    @page {
      margin: 20mm;
      size: A4;
    }
    
    body {
      font-family: 'Arial', sans-serif;
      font-size: 12px;
      line-height: 1.4;
      margin: 0;
      padding: 0;
      direction: ltr;
    }
    
    .header {
      text-align: center;
      margin-bottom: 20px;
      border-bottom: 2px solid #000;
      padding-bottom: 10px;
    }
    
    .logo-title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }
    
    .logo {
      width: 50px;
      height: 50px;
      margin-right: 15px;
    }
    
    .company-name {
      font-size: 18px;
      font-weight: bold;
      color: #000;
    }
    
    .subtitle {
      font-size: 14px;
      color: #666;
      font-style: italic;
    }
    
    .report-title {
      font-size: 16px;
      font-weight: bold;
      margin: 15px 0;
      text-align: center;
      background-color: #f0f0f0;
      padding: 8px;
      border: 1px solid #000;
    }
    
    .info-section {
      margin: 20px 0;
    }
    
    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
    }
    
    .info-table td {
      border: 1px solid #000;
      padding: 8px;
      vertical-align: top;
    }
    
    .label-cell {
      background-color: #f8f8f8;
      font-weight: bold;
      text-align: center;
      width: 150px;
    }
    
    .value-cell {
      background-color: white;
      min-height: 25px;
    }
    
    .financial-summary {
      margin: 20px 0;
    }
    
    .summary-table {
      width: 100%;
      border-collapse: collapse;
      border: 2px solid #000;
    }
    
    .summary-table th,
    .summary-table td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
      font-weight: bold;
    }
    
    .summary-table th {
      background-color: #e0e0e0;
    }
    
    .expenses-section {
      margin: 20px 0;
    }
    
    .expenses-title {
      background-color: #f0f0f0;
      padding: 8px;
      text-align: center;
      font-weight: bold;
      border: 1px solid #000;
      margin-bottom: 0;
    }
    
    .expenses-table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #000;
    }
    
    .expenses-table th,
    .expenses-table td {
      border: 1px solid #000;
      padding: 6px;
      text-align: center;
      vertical-align: middle;
    }
    
    .expenses-table th {
      background-color: #f8f8f8;
      font-weight: bold;
      font-size: 11px;
    }
    
    .expenses-table td {
      font-size: 10px;
      min-height: 30px;
    }
    
    .amount-cell {
      text-align: right;
      font-family: 'Courier New', monospace;
      font-weight: bold;
    }
    
    .arabic {
      font-family: 'Traditional Arabic', 'Tahoma', sans-serif;
      direction: rtl;
    }
    
    .signature-section {
      margin-top: 40px;
      text-align: center;
    }
    
    .print-only {
      display: none;
    }
    
    @media print {
      .no-print { display: none !important; }
      .print-only { display: block !important; }
    }
    
    .page-break {
      page-break-before: always;
    }
  </style>
</head>
<body>
  <div class="header">
    <div class="logo-title">
      <div class="company-info">
        <div class="company-name">PetroMarine Offshore Projects Support Co.</div>
        <div class="subtitle">شركة بترومارين لدعم المشاريع البحرية</div>
      </div>
    </div>
  </div>

  <div class="report-title">
    <div>Petty Cash</div>
    <div class="arabic">كشف العهدة المالية اليومي</div>
  </div>

  <div class="info-section">
    <table class="info-table">
      <tr>
        <td class="value-cell" style="width: 25%;"></td>
        <td class="label-cell">الاسم:</td>
        <td class="value-cell" style="width: 25%;">${pettyCash.employeeName}</td>
        <td class="label-cell">رصيد من اليوم السابق</td>
      </tr>
      <tr>
        <td class="value-cell"></td>
        <td class="label-cell">التاريخ:</td>
        <td class="value-cell">${new Date(pettyCash.date).toLocaleDateString()}</td>
        <td class="label-cell">إجمالي مستلم اليوم</td>
      </tr>
      <tr>
        <td class="value-cell"></td>
        <td class="label-cell">الموقع:</td>
        <td class="value-cell">${pettyCash.location}</td>
        <td class="label-cell">المجموع</td>
      </tr>
      <tr>
        <td class="value-cell"></td>
        <td class="label-cell">الأعمال:</td>
        <td class="value-cell"></td>
        <td class="label-cell">مصروف اليوم</td>
      </tr>
      <tr>
        <td class="value-cell"></td>
        <td class="value-cell"></td>
        <td class="value-cell"></td>
        <td class="label-cell">رصيد آخر اليوم</td>
      </tr>
    </table>
  </div>

  <div class="financial-summary">
    <table class="summary-table">
      <tr>
        <th style="width: 25%;">Previous Balance<br>رصيد من اليوم السابق</th>
        <th style="width: 25%;">Total Received<br>إجمالي مستلم اليوم</th>
        <th style="width: 25%;">Total Expenses<br>مصروف اليوم</th>
        <th style="width: 25%;">Final Balance<br>رصيد آخر اليوم</th>
      </tr>
      <tr>
        <td class="amount-cell">${pettyCash.previousBalance.toFixed(2)}</td>
        <td class="amount-cell">${pettyCash.totalReceived.toFixed(2)}</td>
        <td class="amount-cell">${pettyCash.totalExpenses.toFixed(2)}</td>
        <td class="amount-cell" style="font-weight: bold; ${pettyCash.finalBalance >= 0 ? 'color: green;' : 'color: red;'}">${pettyCash.finalBalance.toFixed(2)}</td>
      </tr>
    </table>
  </div>

  <div class="expenses-section">
    <div class="expenses-title">المصروفات</div>
    <table class="expenses-table">
      <thead>
        <tr>
          <th style="width: 5%;">#</th>
          <th style="width: 40%;">البيان</th>
          <th style="width: 15%;">Class</th>
          <th style="width: 15%;">الفرع</th>
          <th style="width: 15%;">المبلغ</th>
        </tr>
      </thead>
      <tbody>
        ${(pettyCash.expenses || []).map((expense, index) => `
        <tr>
          <td>${index + 1}</td>
          <td style="text-align: left;">${expense.description}</td>
          <td>${expense.class}</td>
          <td>${expense.category}</td>
          <td class="amount-cell">${expense.amount.toFixed(2)}</td>
        </tr>
        `).join('')}
        ${Array.from({ length: Math.max(0, 10 - (pettyCash.expenses?.length || 0)) }, (_, i) => `
        <tr>
          <td>${(pettyCash.expenses?.length || 0) + i + 1}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        `).join('')}
      </tbody>
    </table>
  </div>

  <div class="signature-section">
    <p>Employee Signature: _____________________</p>
    <p>توقيع الموظف</p>
    <br>
    <p>Supervisor Approval: _____________________</p>
    <p>موافقة المشرف</p>
    <br>
    <p>Date: ${new Date().toLocaleDateString()} - التاريخ</p>
  </div>
</body>
</html>`;
};
